<app-authenticate-ui-headline>
	<app-authenticate-ui-headline-title>
		{{"Anmelden" | translate : "label-header-headline" : "feature/auth/login"}}
	</app-authenticate-ui-headline-title>
	<app-authenticate-ui-headline-description>
			{{"Bitte melden Sie sich mit Ihrem Benutzernamen und Ihrem Passwort an." | translate : "label-header-description" : "feature/auth/login"}}
	</app-authenticate-ui-headline-description>
</app-authenticate-ui-headline>
@if(timeoutLogout()){
  <app-shared-notify-chip level="info">
    <ogs-m3-icon prefix="fal" icon="sign-out-alt" />
    <app-shared-notify-chip-value>
      {{ "Sie wurden abgemeldet. Bitte melden Sie sich erneut an." | translate : "status-session-timeout" }}
    </app-shared-notify-chip-value>
  </app-shared-notify-chip>
}

@if (flash(); as f) {
  <app-shared-notify-chip level="info">
    <ogs-m3-icon prefix="fal" icon="person-circle-check" />
    <app-shared-notify-chip-value>
      {{ "Sie wurden bereits registriert. Bitte melden Sie sich mit Ihrer E-Mail-\nAdresse und Ihrem Passwort an." | translate : 'status-already-registered' }}
    </app-shared-notify-chip-value>
  </app-shared-notify-chip>
}
<app-shared-caps-lock-notice />

@if (this.formGroup.errors) {
	<app-authenticate-ui-invalid-credentials-notice />
}

<form [formGroup]="this.formGroup" (ngSubmit)="this.handleSubmit()">
	<mat-form-field>
			<mat-label class="mat-body-large">{{"Benutzername (Email)" | translate : "input-username" : "feature/auth/login"}}</mat-label>
			<input tabindex="1" autocomplete="username" autofocus type="email" matInput formControlName="email" />
			<div class="action__container" matSuffix>
					@if (this.formGroup.get("email")?.value) {
							<button type="button" tabindex="-1" mat-icon-button (click)="this.handleResetOfControl('email')">
									<ogs-m3-icon prefix="fal" icon="times" />
							</button>
					}
					@if (this.formGroup.get("email")?.errors && this.formGroup.get("email")?.touched) {
							<ogs-m3-icon prefix="fal" icon="exclamation-circle" />
					}
			</div>
	</mat-form-field>
	<mat-form-field>
			<mat-label class="mat-body-large">{{"Passwort" | translate : "input-password" : "feature/auth/login"}}</mat-label>
			<input tabindex="2" autocomplete="current-password" matInput [type]="this.hidePassword() ? 'password' : 'text'" formControlName="password" />
			<div class="action__container" matSuffix>
					<button type="button" tabindex="-1" mat-icon-button (click)="this.handleToggleOfPassword()">
							<ogs-m3-icon prefix="fal" [icon]="hidePassword() ? 'eye' : 'eye-slash'" />
					</button>
					@if (this.formGroup.get("password")?.errors && this.formGroup.get("password")?.touched) {
							<ogs-m3-icon prefix="fal" icon="exclamation-circle" />
					}
			</div>
	</mat-form-field>
	<div class="help__container">
			<mat-checkbox tabindex="3" class="example-margin mat-body-medium" formControlName="remember">{{"Benutzernamen merken" | translate : "action-remember-username" : "feature/auth/login"}}</mat-checkbox>
			<button type="button" mat-button (click)="this.handleClickForget()" class="mat-body-medium">{{"Passwort vergessen" | translate : "action-forgot-password" : "feature/auth"}}</button>
	</div>
	<button type="submit" mat-flat-button tabindex="4" class="submit button--tertiary mat-label-large" [disabled]="!this.formGroup.valid || isLoading()">
		{{"Anmelden" | translate : "action-login" : "feature/auth/login"}}
	</button>
</form>